// extracted by mini-css-extract-plugin
export default {"root":"root--mLvYJ","textField":"textField--KPm4W","moveSections":"moveSections--QD4t2","icons":"icons--mydUe"};